<router-outlet></router-outlet>

<!-- Global loading overlay -->
<app-loader-overlay></app-loader-overlay>
